/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';
import { Locale } from '@gh/core-mls';
import { isNil } from 'lodash';

export const ApplicationView = createEnum('ApplicationView', {
  Corporate: 'CORPORATE_VIEW',
  Master: 'MASTER_VIEW',
  Office: 'OFFICE_VIEW',
});

export type ApplicationView = EnumSet<typeof ApplicationView>;

export const APPLICATION_VIEW_CORPORATE: ApplicationView = 'Corporate';
export const APPLICATION_VIEW_MASTER: ApplicationView = 'Master';
export const APPLICATION_VIEW_OFFICE: ApplicationView = 'Office';

export const Language = createEnum('LANGUAGE', {
  en_US: 'EN_US',
  en_AU: 'EN_AU',
  en_NZ: 'EN_NZ',
});

export type Language = EnumSet<typeof Language>;

const LOCALE_TO_INDEX = {
  'en_US': 2,
  'en_AU': 0,
  'en_NZ': 1,
};

export function getLocaleIndex(locale: Locale): number {
  const index = LOCALE_TO_INDEX[locale.toStandardString()];
  if (isNil(index)) {
    throw new Error(`Unknown locale: ${locale}`);
  }
  return index;
}
